import { Stack, Typography } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import { groupByToMap } from "@entrilia/shared/utilities/arrayHelper";
import type { AssignedEntityChange } from "../../../../api/types/workflowTypes";
import { formatAssignedEntityType } from "../changeRequestsFormatters";

interface Props {
  assignedEntityChanges: AssignedEntityChange[];
}

const AssignedEntitiesSection = ({ assignedEntityChanges }: Props) => {
  const changesByType = [...groupByToMap(assignedEntityChanges, (change) => change.type)];

  return changesByType.map(([assignedEntityType, changes]) => (
    <Stack spacing={1.5} key={assignedEntityType} sx={{ alignItems: "flex-start" }}>
      <Stack direction="row" spacing={0.5}>
        <Typography variant="subtitle2">{formatAssignedEntityType(assignedEntityType)}</Typography>
        <BadgeDetached badgeContent={changes.length} color="secondary" />
      </Stack>
      <Stack spacing={0.5} sx={{ alignItems: "flex-start" }}>
        {changes.map((assignedEntity) => (
          <Typography key={assignedEntity.id}>{assignedEntity.displayName}</Typography>
        ))}
      </Stack>
    </Stack>
  ));
};

export default AssignedEntitiesSection;
